import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'

type State = { errorMessage: string } & Status

const initialState = {
  errorMessage: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REMOVE_FROM_PILOT_LIST_ASYNC,
    Actions.REMOVE_FROM_PILOT_LIST_SUCCESS,
    Actions.REMOVE_FROM_PILOT_LIST_FAIL,
    {},
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.REMOVE_FROM_PILOT_LIST_ASYNC:
    case Actions.REMOVE_FROM_PILOT_LIST_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.REMOVE_FROM_PILOT_LIST_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error.message || '',
      }
    }
    default:
      return state
  }
}
